<template>
  <div class="resume-box" :class="{'record-box':isRecord}" @click="handleDetail">
    <div class="right-info">
      <div class="resume-detail">
        <div class="desc text-ellipsis">
          <span v-if="info.is_top" class="top">置顶</span>
          <div class="tit">{{ info.title }}</div>
        </div>
        <div class="price-info">
          <div class="number">{{ info.amount }}</div>
          <div class="unit">{{ info.unit | unitFormat }}</div>
        </div>
      </div>
      <div class="user-info">
        <div class="job-tag">
          <div v-if="info.region_name" class="tag-item">{{ info.region_name }}</div>
          <div v-if="info.categoryInfo.length" class="tag-item subarea">{{ info.categoryInfo[0].name }}</div>
        </div>
        <div v-if="isLog" class="date">{{ (info.view_time || info.call_time) | dateFilter }}</div>
        <div v-else class="date">{{ info.updated_at | dateFilter }}</div>
      </div>
      <div v-if="isLog" class="bottom record-bottom">
        <div v-if="info.user_type === 1" class="info-list">
          <span v-if="info.service_user_name" class="item">{{ info.service_user_name }}</span>
          <span v-if="info.gender" class="item">{{ info.gender===1?'男':'女' }}</span>
          <span v-if="info.age" class="item">{{ info.age }}岁</span>
        </div>
        <template v-if="info.user_type === 2">
          <span>{{ info.company.name }}</span>
        </template>
      </div>
      <div v-else class="bottom resume-bottom">
        <template v-if="info.user_type === 1">
          <img v-if="info.photo_url" class="avatar" :src="info.photo_url + imgSuffix" alt="">
          <img v-else class="avatar" src="../assets/image/default_person.png">
          <div class="info-list">
            <span v-if="info.service_user_name" class="item">{{ info.service_user_name }}</span>
            <span v-if="info.gender" class="item">{{ info.gender===1?'男':'女' }}</span>
            <span v-if="info.age" class="item">{{ info.age }}岁</span>
          </div>
          <base-icon name="icon_person" class="icon" />
        </template>
        <template v-if="info.user_type === 2">
          <img v-if="info.company.logo" class="avatar" :src="info.company.logo.url + imgSuffix" alt="">
          <img v-else class="avatar" src="../assets/image/default_company_logo.png" alt="">
          <span>{{ info.company.name }}</span>
          <base-icon name="icon_company" class="icon" />
        </template>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'AppResumeItem',
  components: {},
  filters: {
    unitFormat(val) {
      const v = Number(val)
      if (v === 1) {
        return '元/小时'
      } else if (v === 2) { return '元/天' }
      else if (v === 3) { return '元/次' }
    },
  },
  props: {
    info: Object,
    type: String,
    isLog: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
    };
  },
  computed: {
    isRecord() {
      return Boolean(this.type === 'record')
    },
    imgSuffix() {
      return '?x-oss-process=image/resize,m_lfit,h_240,w_240'
    },
  },
  methods: {
    handleDetail() {
      this.$router.push({ name: 'resume-id', params: { id: this.info.id } });
    },
  },
}

</script>
<style lang='less' scoped>
.resume-box {
  background: #ffffff;
  border-radius: 16px;
  padding: 36px 30px 20px 30px;
  display: flex;
  flex-direction: row;
  box-sizing: border-box;
  justify-content: flex-start;
  margin-bottom: 18px;
  &.record-box {
    border-top: 1px solid #dcdfe6b2;
    border-radius: 0;
    margin-bottom: 10px;
  }
  .left-avatar {
    .img {
      width: 80px;
      height: 80px;
      border-radius: 24px;
      object-fit: cover;
    }
  }
  .right-info {
    // margin-left: 20px;
    display: flex;
    overflow: hidden;
    align-items: flex-start;
    flex-direction: column;
    flex: 1;
    .resume-detail {
      display: flex;
      flex-direction: row;
      justify-content: space-between;
      align-items: center;
      max-width: 100%;
      width: 100%;
      position: relative;
      top: -3px;
      flex: 1;
      .desc {
        color: #262626;
        font-size: 32px;
        font-weight: bold;
        flex: 1;

        display: flex;
        align-items: center;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
      }
      .tit {
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
      }
      .top {
        flex-shrink: 0;
        display: inline-flex;
        align-items: center;
        justify-content: center;
        padding: 0 5px;
        margin-right: 12px;
        height: 32px;
        background: #FF6000;
        border-radius: 4px;
        font-size: 22px;
        color: #fff;
      }
      .price-info {
        display: flex;
        color: #e84c3d;
        font-weight: bold;
        flex-shrink: 0;
        flex-direction: row;
        margin-left: 15px;
        align-items: center;
        .number {
          font-size: 32px;
          line-height: 32px;
        }
        .unit {
          margin-left: 6px;
          line-height: 32px;
          font-size: 24px;
        }
      }
    }
    .user-info {
      margin: 15px 0 20px 0;
      font-size: 26px;
      color: #666666;
      width: 100%;
      display: flex;
      flex-direction: row;
      align-items: center;
      justify-content: space-between;
      .job-tag {
        position: relative;
        left: -2px;
        display: flex;
        flex-direction: row;
        overflow: hidden;
        flex-wrap: nowrap;
        .tag-item {
          padding: 9px 11px;
          background: #f6f7f8;
          border-radius: 8px;
          font-size: 20px;
          color: #666666;
          white-space: nowrap;
          max-width: 400px;
          text-overflow: ellipsis;
          overflow: hidden;
          white-space: nowrap;
          &.active {
            background: #fef3e3;
            color: #ff6000;
          }
          & + .tag-item {
            margin-left: 10px;
          }
        }
      }
      .date {
        margin-left: 10px;
        white-space: nowrap;
        color: #999999;
      }
    }
    .bottom {
      display: flex;
      flex-direction: row;
      align-items: center;
      padding-top: 18px;
      width: 100%;
      border-top: 1px solid #f1f2f6;
      .avatar {
        width: 40px;
        height: 40px;
        border: 1px solid #e6e6e6;
        border-radius: 8px;
        margin-right: 12px;
      }
      .info-list {
        .item {
          font-size: 24px;
          color: #666666;
          & + .item {
            &::before {
              content: "·";
              font-weight: bold;
              margin: 0 10px;
            }
          }
        }
      }
      span {
        color: #666666;
        font-size: 24px;
      }
      .icon {
        width: 32px;
        height: 32px;
        margin-left: 9px;
      }
    }
    .record-bottom {
      border: none;
      padding-top: 0;
    }
  }
}
</style>